/**
     * @desc 填充盲盒
用户填充盲盒之后回调记录哈希
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/user/putBox', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/user/putBox', params);
}
